import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import googleClassroomLogo from '../../assets/Google_Classroom_Logo.svg';

const styles = {
  button: {
    fontFamily: 'Roboto',
    fontFamilyStyle: 'bold',
  },
};

type Props = {
  open: boolean;
  classroomId: string;
  googleClassroomId: string;
  provider: string;
};

export const SignInDialog = ({ open, classroomId, googleClassroomId, provider }: Props) => {
  let authLink = '/users/auth/google_classroom_student';
  authLink += `?classroom_id=${classroomId}&google_classroom_id=${googleClassroomId}&provider=${provider}`;
  authLink += `&redirect_to=${window.location.pathname}`;

  return (
    <Dialog open={open}>
      <DialogTitle>Welcome to Kyron Learning!</DialogTitle>
      <DialogContent>
        <p>Please sign in with Google to begin this lesson.</p>
      </DialogContent>
      <DialogActions>
        <Button
          component='a'
          sx={styles.button}
          href={authLink}
          data-method='post'
          data-testid='sign-in-with-google-classroom'
          startIcon={<img height='24px' src={googleClassroomLogo} alt='Login with Google' />}
        >
          Sign in with Google
        </Button>
      </DialogActions>
    </Dialog>
  );
};
